import NotFound from './NotFound';


export default NotFound;



// WEBPACK FOOTER //
// ./src/components/NotFound/index.js